var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegaleyseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 48.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b5be2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.33,19.78l0,.1h.1a3.89,3.89,0,0,0,2.2-.74,4,4,0,0,0,1.24-2l0-.09h-.1a4,4,0,0,0-2.2.74A4,4,0,0,0,13.33,19.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.21,14.33,21.33,16,41,2.06l.13-.1-.15,0c-1-.27-2.08-.52-3.13-.75h0L19.3,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.13,5.37,13.23,0l0,0h0C12.07.14,11,.31,9.84.5l-.17,0,8.27,6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.35,14.64l2.18,1.62,0,0L41.34,7.94l0,23.82L22.11,45,2.9,31.76,2.88,8l7.19,5.2.06,0,0-.05A23.06,23.06,0,0,1,12,11.43l.07-.06L0,2.64,0,33.16v0l22,15,0,0,22-15.06,0,0,0-30.38V2.67L27.43,14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.77,9.88,16,8.32,6.57,1.15l0,0h0c-1,.22-2,.47-3,.73l-.15,0,10.42,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.15,21.55a8,8,0,0,0,1.41,5.7l.9,1.1,1-1a14.38,14.38,0,0,1,10-3.81l.72,0a12.52,12.52,0,0,1,9.17,4.22l.05.06,2-1.65-.05-.06a15,15,0,0,0-11-5.14A17.45,17.45,0,0,0,11,24.38a6,6,0,0,1-.28-2.12c.15-2.86,2.25-6,6.1-9L34.48.64l.15-.1-.18,0C33.29.31,32.12.14,31,0h0L15.21,11.27C10.93,14.59,8.55,18.05,8.15,21.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.14 11.07 58.14 13.67 59.84 13.67 59.84 27.62 69.13 27.62 69.13 25.02 62.82 25.02 62.82 11.07 58.14 11.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.6,21h3v2.93a3.38,3.38,0,0,1-2.84,1.13c-2.17,0-3-1.34-3-3.4V17c0-2.06.73-3.4,2.9-3.4a3.26,3.26,0,0,1,3,1.89L102,14.28a5.35,5.35,0,0,0-5.32-3.4c-4.18,0-5.88,2.55-5.88,6.36v4.18c0,3.81,1.7,6.39,5.88,6.39a6.35,6.35,0,0,0,5.7-3V18.44H96.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.61,11.07v2.6h1.45l-4.5,14h3L111.72,24h5.15L118,27.62h3l-5.34-16.55Zm1.79,10.26,1.85-6.08h.09l1.85,6.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "125.19 11.07 125.19 13.67 126.9 13.67 126.9 27.62 136.19 27.62 136.19 25.02 129.88 25.02 129.88 11.07 125.19 11.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "156.47 11.07 156.47 13.67 158.16 13.67 161.91 21.38 161.91 27.62 164.89 27.62 164.89 21.38 169.88 11.07 166.71 11.07 163.44 18.49 163.35 18.49 160.11 11.07 156.47 11.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.61,15.47c0-1.05.5-1.94,2.25-1.94a7.76,7.76,0,0,1,3.74,1.13l1.27-2.2A8.53,8.53,0,0,0,179,10.88c-3.08,0-5.28,1.53-5.28,4.68,0,5.82,7.78,3.52,7.78,7.47,0,1.11-.75,2.13-2.81,2.13a9.15,9.15,0,0,1-4.18-1.25L173.21,26a9.6,9.6,0,0,0,5.7,1.78c3.19,0,5.51-1.75,5.51-4.94C184.42,16.79,176.61,18.63,176.61,15.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "188.92 11.07 188.92 13.67 190.71 13.67 190.71 27.62 200 27.62 200 25.02 193.69 25.02 193.69 20.48 199.48 20.48 199.48 17.88 193.69 17.88 193.69 13.67 200 13.67 200 11.07 188.92 11.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.51 11.07 73.51 13.67 75.22 13.67 75.22 27.62 84.51 27.62 84.51 25.02 78.2 25.02 78.2 20.48 83.99 20.48 83.99 17.88 78.2 17.88 78.2 13.67 84.51 13.67 84.51 11.07 73.51 11.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.59 11.07 140.59 13.67 142.28 13.67 142.28 27.62 151.57 27.62 151.57 25.02 145.26 25.02 145.26 20.48 151.05 20.48 151.05 17.88 145.26 17.88 145.26 13.67 151.57 13.67 151.57 11.07 140.59 11.07"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegaleyseLogo);
export default __webpack_public_path__ + "static/media/legaleyse-logo.62e2ae6f14c73cf6f8d2a07be9611a5e.svg";
export { ForwardRef as ReactComponent };